import React from 'react';
import PropTypes from 'prop-types';
import css from './SurveyDropdown.scss';
import { Surveys } from 'utils/types';
import { SFSurveysTenantLanguage } from "utils/types";
import AccessibleDropdown from 'common/AccessibleDropdown';

export default class SurveyDropdown extends React.Component {

  get options() {
    return this.props.surveys.map(({surveyName, surveyId}) => ({text: surveyName, value: surveyId}));
  }

  render() {
    return (
      <div className={css['surveyDropdown-container']}>
        <div className={css['surveyDropdown-label']}>{`CHOOSE ${this.props.progressSurveyWords.singular.survey.toUpperCase()}`}</div>
        <AccessibleDropdown
          icon="angle down"
          selection
          className={css['item-dropdown']}
          aria-label={`Choose ${this.props.progressSurveyWords.singular.survey}`}
          options={this.options}
          selectOnBlur={false}
          selectOnNavigation={false}
          openOnFocus={false}
          onChange={(e, {value}) => { window.location.href = `#survey/${value}`; }}
          value={this.props.selectedOption}
        />
      </div>
    );
  }

}

SurveyDropdown.propTypes = {
  surveys: Surveys.isRequired,
  selectedOption: PropTypes.number.isRequired,
  progressSurveyWords: SFSurveysTenantLanguage
};
